import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import ReactMoment from "react-moment";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";
import qs from "qs";
import { STORE_STOREORDER_LIST_QUERY } from "../Queries";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../../../Components/Panel/Panel";
import Pagination from "../../../../Components/Pagination/QSP";
import { currencyName } from "../../../../Components/User/UserNames";
import { graphqlUri } from "../../../../Config/Env";

const blockSize = 5;
const first = 15;

const pad = (n) => String(n).padStart(2, "0");
const fmtDate = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// 기간 빠른 선택 버튼 (전체는 가맹점 운영 시작일 기준)
const periodButtons = [
  { id: "ALL", name: "전체" },
  { id: 1, name: "1개월" },
  { id: 3, name: "3개월" },
  { id: 6, name: "6개월" },
  { id: 12, name: "12개월" },
];

export default withRouter(({ location, history }) => {
  const queryString = qs.parse(location.search.substr(1));
  const page = queryString.page ? parseInt(queryString.page) : 1;

  // 기본 기간: 관리자 화면과 동일(전체)
  const today = new Date();

  const startSearchDate = queryString.startSearchDate || "2020-09-01";
  const endSearchDate = queryString.endSearchDate || fmtDate(today);
  const skip = first * (page - 1);

  const [startDate, setStartDate] = useState(startSearchDate);
  const [endDate, setEndDate] = useState(endSearchDate);

  // 기간 버튼/검색으로 URL이 바뀌면 입력칸도 동기화
  useEffect(() => {
    setStartDate(startSearchDate);
    setEndDate(endSearchDate);
  }, [startSearchDate, endSearchDate]);

  const { data, loading } = useQuery(STORE_STOREORDER_LIST_QUERY, {
    variables: {
      startSearchDate: startSearchDate || undefined,
      endSearchDate: endSearchDate || undefined,
      skip,
      first,
    },
    fetchPolicy: "network-only",
  });

  const onSearch = () => {
    const params =
      (startDate ? `startSearchDate=${startDate}&` : "") +
      (endDate ? `endSearchDate=${endDate}&` : "");
    history.push(`/storeOrders?${params}page=1`);
  };

  const onPeriod = (id) => {
    const end = fmtDate(today);
    let start = "2020-09-01";
    if (id !== "ALL") {
      const d = new Date();
      d.setMonth(d.getMonth() - id);
      start = fmtDate(d);
    }
    history.push(
      `/storeOrders?startSearchDate=${start}&endSearchDate=${end}&page=1`
    );
  };

  const onExcel = async () => {
    const token = localStorage.getItem("token");
    const params =
      (startSearchDate ? `startDate=${startSearchDate}&` : "") +
      (endSearchDate ? `endDate=${endSearchDate}&` : "");
    const res = await fetch(`${graphqlUri}/excels/storeOrders?${params}`, {
      method: "POST",
      mode: "cors",
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    if (!res.ok) {
      const msg = await res.text();
      toast.error(msg || "엑셀 다운로드에 실패했습니다.");
      return;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "상점결제내역.xlsx";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    a.remove();
  };

  const baseUrl =
    "/storeOrders?" +
    (startSearchDate ? `startSearchDate=${startSearchDate}&` : "") +
    (endSearchDate ? `endSearchDate=${endSearchDate}&` : "");

  const result = data && data.StoreStoreOrderList;
  const orders = result ? result.storeOrders : [];
  const count = result ? result.count : 0;

  return (
    <>
      <Helmet>
        <title>상점결제내역 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item active">상점결제내역</li>
        </ol>
        <h1 className="page-header">상점결제내역</h1>

        <Panel>
          <PanelHeader noButton={true}>결제내역 ({count}건)</PanelHeader>
          <PanelBody>
            <div className="row m-b-10">
              <div className="col-md-3 m-b-5">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-3 m-b-5">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-2 m-b-5">
                <button className="btn btn-primary btn-block" onClick={onSearch}>
                  검색
                </button>
              </div>
              <div className="col-md-2 m-b-5">
                <button
                  className="btn btn-white btn-block"
                  onClick={onExcel}
                >
                  <i className="fa fa-download m-r-5"></i>엑셀
                </button>
              </div>
            </div>
            <div className="row m-b-10">
              <div className="col-md-12 m-b-5">
                {periodButtons.map((p) => (
                  <button
                    key={p.id}
                    className="btn btn-white m-r-5"
                    onClick={() => onPeriod(p.id)}
                  >
                    {p.name}
                  </button>
                ))}
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-striped m-b-0">
                <thead>
                  <tr>
                    <th>가맹점</th>
                    <th>캐셔</th>
                    <th>주문번호</th>
                    <th>거래번호</th>
                    <th>금액</th>
                    <th>내역정보</th>
                    <th>거래일자</th>
                    <th>생성자</th>
                  </tr>
                </thead>
                <tbody>
                  {(loading || count === 0) && (
                    <tr>
                      <td colSpan={8} className="text-center">
                        {loading ? "불러오는 중..." : "결제내역이 없습니다."}
                      </td>
                    </tr>
                  )}
                  {!loading &&
                    orders.map((o) => (
                      <tr key={o.id}>
                        <td>{o.store ? o.store.name : "-"}</td>
                        <td>
                          {o.cashier
                            ? `${o.cashier.name}(${o.cashier.userId})`
                            : "-"}
                        </td>
                        <td>
                          <ReactMoment format="YYMMDD-HHmmssSSS">
                            {o.createdAt}
                          </ReactMoment>
                        </td>
                        <td>
                          {o.accountUserLedger ? (
                            <ReactMoment format="YYMMDD-HHmmssSSS">
                              {o.accountUserLedger.createdAt}
                            </ReactMoment>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td align="right">
                          <NumberFormat
                            value={o.value}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                          {currencyName(o.currency)}
                        </td>
                        <td>
                          {o.accountUserLedger
                            ? o.accountUserLedger.title
                            : "-"}
                        </td>
                        <td>
                          {o.accountUserLedger ? (
                            <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                              {o.accountUserLedger.createdAt}
                            </ReactMoment>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {o.creator
                            ? `${o.creator.name}(${o.creator.userId})`
                            : "-"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
          {count > 0 && (
            <PanelFooter>
              <Pagination
                totalRecord={count}
                blockSize={blockSize}
                pageSize={first}
                currentPage={page}
                baseUrl={baseUrl}
              />
            </PanelFooter>
          )}
        </Panel>
      </div>
    </>
  );
});
